import { api } from 'src/api';

export interface OnboardingItem {
  _id: string;
  onboarding: string;
  status: 'NOT_STARTED' | 'IN_PROGRESS' | 'FINISHED';
}

export interface OnboardingListResponse {
  data: OnboardingItem[];
}

export interface OnboardingFinishResponse {
  data: OnboardingItem;
}

export const OnboardingService = {
  async listUnfinished(): Promise<OnboardingListResponse> {
    const response = await api.get<OnboardingListResponse>('/onboarding/list-unfinished');
    return response.data;
  },

  async finish(onboardingId: string): Promise<OnboardingFinishResponse> {
    const response = await api.post<OnboardingFinishResponse>(`/onboarding/finish/${onboardingId}`);
    return response.data;
  },
};
